/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2021, a Tencent company. All rights reserved
 */
export default (): void => {
  window.addEventListener('load', () => {
    const { body } = document;
    if (body) {
      // if (body.classList.contains('alpha-version')) {
      const img = new Image();
      img.onload = function () {
        const i = document.createElement('script');
        body.appendChild(i);
        i.src = 'https://ui.tad.woa.com/tools/odc-devtools/index.js';
        i.remove();
      };
      img.src = 'https://ui.tad.woa.com/tools/odc-devtools/check.png';
      // }
    }
  }, {
    once: true,
  });
};
